/**CORE LIBRARIES IMPORT */
import React from "react";

/**DATA IMPORT */
import { formatPrice } from "../data/events";

/**
 * Display-only drinks price list for an event (no sales or checkout).
 * `compact` is the smaller version used inside the homepage event card.
 */
const EventDrinks = ({ drinks, currency = "EUR", compact = false }) => {
  if (!drinks?.items?.length) return null;

  return (
    <div className={`event-drinks ${compact ? "event-drinks-compact" : ""}`}>
      <p className="event-menu-heading">Drinks · served by {drinks.servedBy}</p>

      {drinks.items.map((drink) => (
        <div key={drink.name} className="drink">
          <p className="drink-name" lang="tr">{drink.name}</p>
          <ul className="drink-options">
            {drink.options.map((opt) => (
              <li key={opt.label}>
                <span className="drink-option-label">{opt.label}</span>
                <span className="drink-option-leader" aria-hidden="true" />
                <span className="drink-option-price">{formatPrice({ amount: opt.price, currency })}</span>
              </li>
            ))}
          </ul>
        </div>
      ))}

      <p className="drinks-note">{drinks.note}</p>
    </div>
  );
};

export default EventDrinks;
